// Reuse server-rendered Money values and the theme's existing product response.
// These elements do not duplicate price arithmetic or make another network request.
if (!customElements.get('promotion-badge')) {
  customElements.define('promotion-badge', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.scheduleFit = () => {
        if (!this.isConnected) return;
        if (typeof requestAnimationFrame === 'undefined') {
          this.fitAmount();
          return;
        }
        cancelAnimationFrame(this.fitFrame);
        this.fitFrame = requestAnimationFrame(() => this.fitAmount());
      };
      // Observe the media container, whose dimensions do not depend on this
      // absolutely positioned badge, to avoid a resize feedback loop.
      const host = this.closest('.promotion-badge-host, .product-card__figure, .pdp-promotion-slot');
      if (host && typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.scheduleFit);
        this.resizeObserver.observe(host);
      }
      window.addEventListener('resize', this.scheduleFit, { signal: this.abortController.signal });
      document.fonts?.addEventListener('loadingdone', this.scheduleFit, { signal: this.abortController.signal });
      document.fonts?.ready.then(this.scheduleFit);
      this.scheduleFit();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      if (typeof cancelAnimationFrame !== 'undefined') cancelAnimationFrame(this.fitFrame);
    }

    fitAmount() {
      const amount = this.querySelector('.promotion-badge__amount');
      if (!this.isConnected || !amount) return;
      // Reset first so a wider card or breakpoint can restore the configured size.
      amount.style.removeProperty('font-size');
      const availableWidth = amount.clientWidth;
      if (!availableWidth || amount.scrollWidth <= availableWidth) return;
      const fontSize = parseFloat(getComputedStyle(amount).fontSize);
      const fittedSize = fontSize * availableWidth / amount.scrollWidth * 0.98;
      amount.style.fontSize = `${Math.max(1, Math.floor(fittedSize * 100) / 100)}px`;
    }
  });
}

if (!customElements.get('pdp-promotion-badge')) {
  customElements.define('pdp-promotion-badge', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const form = document.getElementById(this.getAttribute('form'));
      form?.addEventListener('product:rerender', (event) => {
        if (!this.isConnected) return;
        const next = event.detail?.htmlFragment?.querySelector(`#${CSS.escape(this.id)}`);
        const template = next?.querySelector('[data-pdp-promotion-content]');
        if (!template) return;

        this.dataset.mediaId = next.dataset.mediaId;
        this.querySelector('[data-pdp-promotion-content]').replaceWith(template.cloneNode(true));
        this.updateBadge();
      }, { signal: this.abortController.signal });
      this.updateBadge();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    updateBadge() {
      const template = this.querySelector('[data-pdp-promotion-content]');
      if (!template) return;
      this.closest('product-gallery')?.querySelectorAll('[data-pdp-promotion-slot]').forEach((slot) => {
        slot.replaceChildren();
        if (slot.dataset.pdpPromotionSlot === this.dataset.mediaId) {
          slot.append(template.content.cloneNode(true));
        }
      });
    }
  });
}

if (!customElements.get('card-promotion-badge')) {
  customElements.define('card-promotion-badge', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.closest('product-card')?.addEventListener('change', (event) => {
        const input = event.target;
        if (!input.matches('.product-card__swatch-list input[data-variant-id], .product-card__variant-list input[data-variant-id]')) return;
        const template = this.querySelector(`template[data-promotion-variant="${CSS.escape(input.dataset.variantId)}"]`);
        if (!template) return;

        const state = template.content.cloneNode(true);
        this.querySelector('[data-card-promotion-content]').replaceWith(state.querySelector('[data-card-promotion-content]'));
        const price = this.closest('product-card').querySelector('[data-promotion-card-price]');
        if (price) price.replaceChildren(...state.querySelector('[data-promotion-card-price]').childNodes);
      }, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}
